module.exports = __webpack_public_path__ + "img/section1SwiperTab3.905f14c6.png";